import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import { DimensionOptionResultDto } from '../../common/dimensions/dimension-option-result-dto';
import { ARCreditApplicationTransactionItemResultDto } from './ar-credit-application-transaction-item-result-dto';
const ɵ0 = () => DimensionOptionResultDto, ɵ1 = () => Date, ɵ2 = () => Date, ɵ3 = () => ARCreditApplicationTransactionItemResultDto;
export class ARCreditApplicationSourceTransactionResultDto {
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Array)
], ARCreditApplicationSourceTransactionResultDto.prototype, "dimensions", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Date)
], ARCreditApplicationSourceTransactionResultDto.prototype, "documentDate", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Date)
], ARCreditApplicationSourceTransactionResultDto.prototype, "postDate", void 0);
tslib_1.__decorate([
    Type(ɵ3),
    tslib_1.__metadata("design:type", Array)
], ARCreditApplicationSourceTransactionResultDto.prototype, "lineItems", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3 };
